import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const OrderSummary = () => {

  const {  clearCart } = useCart();
  const { state } = useLocation();
  const { cart, checkoutData, subtotal: passedSubtotal, shipping: passedShipping } = state || {};

  const subtotal = cart?.reduce((sum, item) => {
    const variants = item.variants || [];
    const itemTotal = variants.reduce(
      (vSum, v) => vSum + Number(v.price || 0) * Number(v.quantity || 0),
      0
    );
    return sum + itemTotal;
  }, 0) ?? passedSubtotal ?? 0;

  const shipping = subtotal > 50 ? 0 : (passedShipping ?? checkoutData?.delivery_salary ?? 0);
  const total = subtotal + shipping;
  const deliverySalary = subtotal > 50 ? 0 : (checkoutData?.delivery_salary ?? shipping);

  const navigate = useNavigate();
  const [order, setOrder] = React.useState(null);
  const [items, setItems] = React.useState([]);
  
  React.useEffect(() => {
    // if (!state?.orderId) {
    //   navigate('/cart');
    //   return;
    // }
  
    // const fetchOrder = async () => {
    //   const token = sessionStorage.getItem("token");
  
    //   const res = await fetch(
    //     `${process.env.REACT_APP_API_URL}/api/orders/${state.orderId}`,
    //     {
    //       headers: { Authorization: `Bearer ${token}` }
    //     }
    //   );
  
    //   const data = await res.json();
  
    //   if (res.ok) {
    //     setOrder(data.order);
    //     setItems(data.items);
    //   }
    // };
  
    // fetchOrder();
  }, [state, navigate]);

  
  // if (!order) {
  //   return (
  //     <div className="container py-5 text-center">
  //       <p>Loading order...</p>
  //     </div>
  //   );
  // }
  

  const handleConfirm = async () => {
    try {
      const token = localStorage.getItem("token");
  
      const lineItems = [];
  
      cart.forEach(item => {
        item?.variants?.forEach(variant => {
          lineItems.push({
            item_id: item.productId,
            item_name: item.name,
            sku: variant.sku,
            qty: variant.quantity,
            price: variant.price,
            size: variant.size,
            color: variant.color,
            gender: variant.gender,
            age: variant.age,
            lengthcm: variant.lengthcm,
          });
        });
      });
  
      const body = {
        items: lineItems,
        shipping: {
          name: checkoutData.name,
          phone: checkoutData.phone,
          address: checkoutData.address,
          delivery_salary: deliverySalary,
          city: checkoutData.city || ""
        }
      };
  
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/orders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });
  
      const data = await res.json();
  
      if (!res.ok) {
        alert("Order failed");
        return;
      }
  
      clearCart();
      navigate(`/order-success/${data.order.id}`);
  
    } catch (err) {
      alert("Something went wrong");
    }
  };
  if (!state) {
    navigate('/cart');
    return null;
  }
  return (
    <div className="container py-5">
      <div className="card shadow-sm border-0 mx-auto" style={{ maxWidth: '600px' }}>
        <div className="card-body p-4">
          <h3 className="fw-bold mb-4">Order Summary</h3>
          
          <div className="mb-4">
            {cart?.map((item, idx) =>
  item.variants?.map((v, i) => (
    <div key={`${idx}-${i}`} className="d-flex justify-content-between mb-2 pb-2 border-bottom">
      <div>
        <span className="fw-bold">{item.name}</span>

        <div className="d-flex flex-row gap-3 text-muted">
          {v.size && <span>{v.size}</span>}

          {v.color && (
            <div
              style={{
                backgroundColor: v.color,
                width: "20px",
                height: "20px",
                borderRadius: "50%",
              }}
            />
          )}

          <span>${v.price}</span>
          <span>x{v.quantity}</span>
        </div>
      </div>

      <span className="fw-bold">
        ${(v.price * v.quantity).toFixed(2)}
      </span>
    </div>
  ))
)}
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span>Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span>Delivery</span>
            <span>${shipping.toFixed(2)}</span>
          </div>
          <div className="d-flex justify-content-between fs-5 fw-bold mb-4">
            <span>Total to Pay:</span>
            <span className="text-success">${total.toFixed(2)}</span>
          </div>

          <div className="bg-light p-3 rounded mb-4">
            <h6 className="fw-bold small text-uppercase text-muted">Shipping to:</h6>
            <p className="mb-0 small">
              {checkoutData.name}<br/>
              {checkoutData.address}
              {checkoutData.city && `, ${checkoutData.city}`}
            </p>
          </div>
          <div className="d-grid gap-2">
            <button onClick={handleConfirm} className="btn btn-success btn-lg shadow-sm">
              Confirm Order
            </button>
            <button onClick={() => navigate('/cart')} className="btn btn-link text-muted">
              Cancel & Return to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;